import axiosInstance from '../helpers/axios';
import { getToken } from './auth';

// Get annotation
export const getAnnotationsOrder = async (idOrder) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/order/annotation/?order=${idOrder}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get annotations' info
export const getAnnotationInfoOrder = async (idAnnotation) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/order/annotation/${idAnnotation}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register annotation
export const registerAnnotationOrder = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/order/annotation/create/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update annotation
export const updateAnnotationOrder = async (idAnnotation, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/order/annotation/update/${idAnnotation}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Delete annotation
export const deleteAnnotationOrder = async (idAnnotation, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/order/annotation/${idAnnotation}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};
